import { Component, OnInit, NgZone } from '@angular/core';
import { ReportsService } from '../reports/reports.service';
import { VMwareProducts } from '../models/vmwareproducts';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/Rx';
import { NumberConstants } from "../common/numberconstants";
import { Globals } from 'app/common/globals';
import { EnvironmentsService } from 'app/services/enviornment.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Params, Route, Router } from '@angular/router';

@Component({
    styleUrls: ['./compare.component.scss'],
    templateUrl: './compare.component.html'
})
export class CompareComponent implements OnInit {
    compareOpen: Boolean = false;
    langSub: Subscription;
    counts: Array<number> = [];
    compareRel: Array<String> = [];
    versions: any;
    productsRight: VMwareProducts[];
    selectedprodctID: any;
    selectedCompVer: any;
    version: any;
    selectedprodctName: any;
    splicedObj: any;
    temps: any = new Array();
    versionNum: any;
    isTempVersion: Boolean = false;
    currentVersions: Array<number> = [];
    comparisonTable: any = new Array();
    comparisonVerIds: any = new Array();
    jsonData: any = new Array();
    comparisions: any;
    comparisionsRelease: any;
    compareleases: any = new Array();
    compcategories: any = new Array();
    catBlock: any = new Array();
    allItems: {};
    currentUser = JSON.parse(localStorage.getItem('currentUser'));
    private subscription: Subscription;
    constructor(private zone: NgZone, private route: ActivatedRoute,private reportservice: ReportsService,private numberConstant:NumberConstants,private globals: Globals,private envService: EnvironmentsService, private translateService: TranslateService) { }

    ngOnInit() {
        this.subscription = this.route.queryParams.subscribe((params: Params) => {
            if (params['vmwareproduct']) {
                this.reportservice.selectedBookmarkedprod = params["vmwareproduct"];
                this.reportservice.selectedBookmarkedversion = params["release"];
                this.reportservice.selectedBookmarkedCategories = params["categories"];
                }
                else{
                    this.reportservice.selectedBookmarkedprod = this.reportservice.selectedprodName;
                    this.reportservice.selectedBookmarkedversion = this.reportservice.selectedverName;
                    this.reportservice.selectedBookmarkedCategories = "";
                }
            });
        this.subscription = this.reportservice.notifyObservable$.subscribe((res) => {
            this.selectedprodctID = this.reportservice.selectedprodID;
            this.selectedprodctName = this.reportservice.selectedprodName;
            if (this.currentUser != null) {
                this.versions = this.getSelProductVersions(this.selectedprodctID, false, this.numberConstant.HASCONFIGSET);
            } else {
                this.versions = this.getSelProductVersions(this.selectedprodctID, false, this.numberConstant.HASCONFIGSETANDPUBLISHED);
            }
            this.isTempVersion = false;
        });
        this.getProductInConfigSet();
    }
    getProductInConfigSet(): void {
        this.reportservice.getProducts(null).subscribe(
            vmwareproducts => {
                let filteredProductsRight: Array<any> = [];
                vmwareproducts.forEach(vmwareprod => {
                    if(vmwareprod.support === true) {
                        filteredProductsRight.push(vmwareprod);
                    }
                });
                this.productsRight = filteredProductsRight;
                this.productsRight = vmwareproducts;
                this.reportservice.selectedprodID = this.productsRight[this.numberConstant.ZERO].id;
                if (this.currentUser != null) {
                    this.versions = this.getSelProductVersions(this.reportservice.selectedprodID, false, this.numberConstant.HASCONFIGSET);
                } else {
                    this.versions = this.getSelProductVersions(this.reportservice.selectedprodID, false, this.numberConstant.HASCONFIGSETANDPUBLISHED);
                }

            },
            err => {
                // Log errors if any
                console.log(err);
            }
        );
    }

    addSelect(selectedRel) {
        if (selectedRel != null && selectedRel && selectedRel.value == "Default") {
            return;
        }
        if (this.versions.length > this.numberConstant.ZERO && this.selectedCompVer != null) {
            this.counts.push(this.counts.length + this.numberConstant.ONE);

            for (let version of this.versions) {
                if (version.value == this.selectedCompVer) {
                    this.splicedObj = this.versions.splice(this.versions.indexOf(version), this.numberConstant.ONE);
                    this.temps.push(
                        this.splicedObj[this.numberConstant.ZERO]
                    );
                    break;
                }
            }
            this.compareRel[this.counts.length] = this.selectedCompVer;
            this.versionNum = this.versions.length;
            this.isTempVersion = true;
        }
    }

    deleteSelect(btnId) {
        this.counts.pop();
        for (let temp of this.temps) {
            if (temp.value == this.compareRel[btnId]) {
                this.splicedObj = this.temps.splice(this.temps.indexOf(temp), this.numberConstant.ONE );
                this.versions.push(
                    this.splicedObj[this.numberConstant.ZERO]
                );
                break;
            }
        }
        this.versionNum = this.versions.length;
        this.isTempVersion = true;
    }

    onReleaseSelected(currValue) {
        this.selectedCompVer = currValue;
        this.addSelect(null);
    }

    getSelProductVersions(prodId, isprod, urlIndex): void {
        this.temps = [];
        this.reportservice.getProductVersions(prodId, urlIndex)
            .subscribe(vmwareproductsVersions => {
                let arr: any = new Array();
                this.currentVersions = vmwareproductsVersions
                let filteredVersions: Array<any> = [];
                vmwareproductsVersions.forEach(vmwareversion => {
                    if(vmwareversion.support === true) {
                        filteredVersions.push(vmwareversion);
                    }
                });
                this.counts = [];
                filteredVersions.forEach(element => {
                    if (element.id != this.reportservice.selectedversionID) {
                        arr.push({
                            id: element.id, value: element.rmVmwPrdRelVersion
                        });
                    }
                    this.versions = arr;
                    this.versionNum = this.versions.length;
                });
            },
                err => {
                    this.versions = [];
                    this.versionNum = this.numberConstant.ZERO;
                    console.log(JSON.stringify(err));
                });
                this.reportservice.onBookMark("/repcomp/compare",false,false,false);
    }

    openCompare(): void {
        this.comparisonTable = [];
        this.comparisonVerIds = [];
        for (let subitem of this.temps) {
            this.comparisonTable.push(
                { id: subitem['id'], value: subitem['value'] }
            );
        }
        for (let verItem of this.comparisonTable) {
            this.comparisonVerIds.push(
                verItem['id']
            );
        }
        this.compareOpen = true;
        this.reportservice.getComparisonTable(this.selectedprodctID, this.comparisonVerIds, this.reportservice.selectedversionID)
            .subscribe(compareTable => {
                this.comparisionsRelease = compareTable.releases;
                if (this.currentUser != null) {
                    var categoriesArr = [];
                    for (var item of compareTable.categories) {
                        item.attributes.forEach(attr => {
                            if (attr.attributeValues != null && attr.attributeValues.length > this.numberConstant.ZERO) {
                                let arr: any = [];
                                attr.attributeValues.forEach(values => {
                                    var vals = values.split("-/-")
                                    arr.push(vals[this.numberConstant.ZERO]);
                                });
                                attr.attributeValues = arr;
                            }
                        });
                        if (item.attributes.length > this.numberConstant.ZERO) {
                            categoriesArr.push(item);
                        }
                    }
                    this.comparisions = categoriesArr;

                } else {
                    var categoriesArr = [];
                    for (var item of compareTable.categories) {
                        item.attributes.forEach(attr => {
                            if (attr.attributeValues != null && attr.attributeValues.length > this.numberConstant.ZERO) {
                                let arr: any = [];
                                attr.attributeValues.forEach(values => {
                                    var vals = values.split(this.numberConstant.SEPERATOR)
                                    if (vals[this.numberConstant.LABEL] === this.numberConstant.APPROVEDSTATUSSTRING &&
                                        vals[this.numberConstant.KEYOBJECT] === this.numberConstant.ISINTRNAL) {
                                        arr.push(vals[this.numberConstant.ZERO]);
                                    } else {
                                        arr.push(this.numberConstant.NOTAPPLICALBLE);
                                    }
                                });
                                attr.attributeValues = arr;
                            }
                        });
                        if (item.attributes.length > this.numberConstant.ZERO) {
                            categoriesArr.push(item);
                        }
                    }
                    this.comparisions = categoriesArr;
                }
                this.allItems = compareTable;
            },
                err => {
                    console.log(JSON.stringify(err));
                });

    }

    download() {
        var options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            showTitle: false,
            useBom: true,
            headers: ['Category', 'Category Values']

        };
        let csvData = this.ConvertToCSV(this.allItems);
        var a = document.createElement("a");
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        var blob = new Blob([csvData], { type: 'text/csv;charset=utf8' });
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = this.selectedprodctName + ' Configuration Maximums Comparison.csv';
        a.click();
    }

    // convert Json to CSV data
    ConvertToCSV(objArray) {
        let releases = objArray.releases;
        let categories = objArray.categories;
        var array = typeof releases != 'object' ? JSON.parse(releases) : releases;
        var str = '';
        var row = this.addReleases(array);
        str += row + '\r\n';
        var date = this.addTimeStamp();
        str += date + '\r\n';
        var catarray = categories;
        var catstr = '';
        for (var i = this.numberConstant.ZERO; i < catarray.length; i++) {
            var line = '';
            if (line != '') line += ','
            line += '"' + catarray[i].categoryName + '"';
            var attrarray = typeof catarray[i].attributes != 'object' ? JSON.parse(catarray[i].attributes) : catarray[i].attributes;
            var attrstr = '';
            if (attrarray.length > this.numberConstant.ZERO) {
                for (var j = this.numberConstant.ZERO; j < attrarray.length; j++) {
                    var attrline = '';
                    var key = '"' + attrarray[j].attributKey + '"';
                    var values = this.valuecommaHandler(attrarray[j].attributeValues);
                    attrline += key + "," + values;
                    if (j === this.numberConstant.ZERO)
                        attrstr += attrline + '\r\n'
                    else
                        attrstr += " ," + attrline + '\r\n'
                }
                line += '\r\n' + " ," + attrstr;
            } else {
                line += " ," + line;
            }
            catstr += '\r\n' + line + '\r\n';
        }
        str += catstr + '\r\n';
        return str;

    }

    valuecommaHandler(array: any): any {
        var arr = [];
        if (array != null && array.length > this.numberConstant.ZERO) {
            for (var i = this.numberConstant.ZERO; i < array.length; i++) {
                var val = '"' + array[i] + '"';
                arr.push(val);
            }
        }
        return arr;
    }
    addReleases(array: any): String {
        var row = "";
        row = " " + "," + this.globals.limitLabel + ",";
        for (var index in array) {
            row += array[index] + "" + ',';
        }
        row = row + "\r\n";
        row = row.slice(this.numberConstant.ZERO, this.numberConstant.MINUS_ONE);
        return row;
    }

    addTimeStamp(): String {
        var row = "";
        var lastdownLoaded: Date;
        row = "Report Downloaded On:" + "," + new Date() + ",";
        row = row + "\r\n";
        row = row.slice(this.numberConstant.ZERO, this.numberConstant.MINUS_ONE);
        return row;
    }
}



// WEBPACK FOOTER //
// ./src/app/compare/compare.component.ts